export default __webpack_public_path__ + "images/L8.760c5a3.png";